import store from '@/store';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const DEDICATED_MATERIALS = [
  {
    name: 'LS-WMTB-AL (100X15) BK',
    articleNumber: '0831511',
  },
  {
    name: 'LS-WMTB-AL (29X8) BK',
    articleNumber: '0831508',
  },
  {
    name: 'LS-WMTB-AL (40X15) BK',
    articleNumber: '0831509',
  },
  {
    name: 'LS-WMTB-AL (60X15) BK',
    articleNumber: '0831510',
  },
  {
    name: 'LS-WMTB-AL (D25) BK',
    articleNumber: '0831512',
  },
  {
    name: 'LS-WMTB-AL (D30) BK',
    articleNumber: '0831513',
  },
  {
    name: 'LS-EMLP-AL (100X60) BK',
    articleNumber: '0831595',
  },
  {
    name: 'LS-EMLP-AL (27X15) BK',
    articleNumber: '0831589',
  },
  {
    name: 'LS-EMLP-AL (27X18) BK',
    articleNumber: '0831590',
  },
  {
    name: 'LS-EMLP-AL (49X15) BK',
    articleNumber: '0831591',
  },
  {
    name: 'LS-EMLP-AL (60X15) BK',
    articleNumber: '0831592',
  },
  {
    name: 'LS-EMLP-AL (60X30) BK',
    articleNumber: '0831593',
  },
  {
    name: 'LS-EMLP-AL (60X30) BU',
    articleNumber: '0831606',
  },
  {
    name: 'LS-EMLP-AL (60X30) GN',
    articleNumber: '0831610',
  },
  {
    name: 'LS-EMLP-AL (60X30) OG',
    articleNumber: '0831602',
  },
  {
    name: 'LS-EMLP-AL (60X30) RD',
    articleNumber: '0831598',
  },
  {
    name: 'LS-EMLP-AL (85,6X54) BK',
    articleNumber: '0831594',
  },
  {
    name: 'LS-EMLP-AL (85,6X54) BU',
    articleNumber: '0831607',
  },
  {
    name: 'LS-EMLP-AL (85,6X54) GN',
    articleNumber: '0831611',
  },
  {
    name: 'LS-EMLP-AL (85,6X54) OG',
    articleNumber: '0831603',
  },
  {
    name: 'LS-EMLP-AL (85,6X54) RD',
    articleNumber: '0831599',
  },
  {
    name: 'LS-EMP-AL (100X60) BK',
    articleNumber: '0831675',
  },
  {
    name: 'LS-EMP-AL (27X15) BK',
    articleNumber: '0831669',
  },
  {
    name: 'LS-EMP-AL (49X15) BK',
    articleNumber: '0831671',
  },
  {
    name: 'LS-EMP-AL (60X30) BK',
    articleNumber: '0831673',
  },
  {
    name: 'LS-EMP-AL (85,6X54) BK',
    articleNumber: '0831674',
  },
  {
    name: 'LS-EMSP-AL (110X80) BK',
    articleNumber: '0831631',
  },
  {
    name: 'LS-EMSP-AL (110X80) BU',
    articleNumber: '1050854',
  },
  {
    name: 'LS-EMSP-AL (150X120) BK',
    articleNumber: '0831633',
  },
  {
    name: 'LS-EMSP-AL (150X80) BK',
    articleNumber: '0831632',
  },
  {
    name: 'LS-EMSP-AL (170X180) BK',
    articleNumber: '0831634',
  },
  {
    name: 'LS-EMSP-AL (39X15) BK',
    articleNumber: '0831626',
  },
  {
    name: 'LS-EMSP-AL (50X15) BK',
    articleNumber: '0831627',
  },
  {
    name: 'LS-EMSP-AL (50X30) 2H BK',
    articleNumber: '0803990',
  },
  {
    name: 'LS-EMSP-AL (50X30) BK',
    articleNumber: '0831628',
  },
  {
    name: 'LS-EMSP-AL (50X30) BU',
    articleNumber: '0831645',
  },
  {
    name: 'LS-EMSP-AL (50X30) RD',
    articleNumber: '0831637',
  },
  {
    name: 'LS-EMSP-AL (75,6X54) BK',
    articleNumber: '0831629',
  },
  {
    name: 'LS-EMSP-AL (75,6X54) BU',
    articleNumber: '0831646',
  },
  {
    name: 'LS-EMSP-AL (75,6X54) GN',
    articleNumber: '0831650',
  },
  {
    name: 'LS-EMSP-AL (75,6X54) OG',
    articleNumber: '0831642',
  },
  {
    name: 'LS-EMSP-AL (75,6X54) RD',
    articleNumber: '0831638',
  },
  {
    name: 'LS-EMSP-AL (90X60) BK',
    articleNumber: '0831630',
  },
  {
    name: 'PML-M100 (D100)R',
    articleNumber: '1014181',
  },
  {
    name: 'PML-M100 (D50)R',
    articleNumber: '1014180',
  },
  {
    name: 'PML-T101 (26X280)R',
    articleNumber: '1014229',
  },
  {
    name: 'PML-T102 (26X280)R',
    articleNumber: '1014231',
  },
  {
    name: 'PML-T107 (26X280)R',
    articleNumber: '1014241',
  },
  {
    name: 'PML-T108 (26X280)R',
    articleNumber: '1014243',
  },
  {
    name: 'PML-T109 (26X280)R',
    articleNumber: '1014245',
  },
  {
    name: 'PML-T110 (26X280)R',
    articleNumber: '1014247',
  },
  {
    name: 'US-PML-M100 (D100)',
    articleNumber: '1014177',
  },
  {
    name: 'US-PML-M100 (D50)',
    articleNumber: '1014176',
  },
  {
    name: 'WMS 12,7 (EX20)R BK',
    articleNumber: '0800422',
  },
  {
    name: 'WMS 19,1 (EX30)R BK',
    articleNumber: '0800423',
  },
  {
    name: 'WMS 2,4 (EX4)R BK',
    articleNumber: '0800415',
  },
  {
    name: 'WMS 25,4 (EX40)R BK',
    articleNumber: '0800424',
  },
  {
    name: 'WMS 25,4 (EX40)RL BK',
    articleNumber: '0800435',
  },
  {
    name: 'WMS 3,2 (EX5)R BK',
    articleNumber: '0800416',
  },
  {
    name: 'WMS 38,1 (EX60)R BK',
    articleNumber: '0800425',
  },
  {
    name: 'WMS 4,8 (EX9)R BK',
    articleNumber: '0800418',
  },
  {
    name: 'WMS 6,4 (EX10)R BK',
    articleNumber: '0800419',
  },
  {
    name: 'WMS 9,5 (EX16)R BK',
    articleNumber: '0800421',
  },
  {
    name: 'WMTB HF (40X12)R BK',
    articleNumber: '1369829',
  },
  {
    name: 'WMTB HF (40X18)R BK',
    articleNumber: '1369835',
  },
  {
    name: 'EMLP (40X8)R BK',
    articleNumber: '1097012',
  },
  {
    name: 'EMLP (EX15)R BK',
    articleNumber: '0803279',
  }
];

export default () => {
  const { core: { colorSchema } } = store.getState();
  const matfileTemplate = getBuildedMatfileTemplate();

  return DEDICATED_MATERIALS.some(item => matfileTemplate?.name.includes(item.name) || `${colorSchema?.article_number || ''}` === item.articleNumber);
};
